import { initEnvironmentReact } from '../../shared/initEnvironmentReact'

const FINGERPRINT_TOKEN = import.meta.env.VITE_FINGERPRINT_TOKEN ?? initEnvironmentReact.FINGERPRINT_TOKEN

export const FGP_TOKEN = FINGERPRINT_TOKEN as string
